import React, { useEffect, useState, memo } from 'react';
import axios from 'axios';
import FlipNumbers from 'react-flip-numbers';
import { Card } from 'react-bootstrap';
import getShiftStartEndTime from '../charts/utils/chartUtils.js';
import { useAppContext } from '../../providers/AppProvider.js';
import { FallingLines } from 'react-loader-spinner';
import { isLiveTimeRange } from '../charts/utils/chartUtils';
import { INFLUX_API } from '../../config/api';

const FlipNumber = ({
  bucket,
  machineName,
  time,
  startTime,
  endTime,
  title
}) => {
  const [count, setCount] = useState(0);
  const {
    config: { theme },
    getThemeColor
  } = useAppContext();
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${INFLUX_API}/api/influx/${machineName}/active-break?start=${startTime}&end=${endTime}&bucket=${bucket}`
      );
      setCount((response.data[time] / 60).toFixed(2));
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Function to fetch data from the API using axios
    fetchData();
    const intervalId = isLiveTimeRange(endTime) ? setInterval(fetchData, 60000) : null;
    return () => clearInterval(intervalId);
  }, [startTime, endTime]);

  if (!count) {
    return (
      <Card className="h-100">
        <Card.Body style={{ height: '316px', width: '100%' }}>
          <div style={styles.spinnerContainer}>
            <FallingLines
              color={theme === 'dark' ? 'white' : '#3874ff'}
              width="100"
              visible={true}
              ariaLabel="falling-circles-loading"
              // wrapperStyle ={styles.spinnerContainer}
            />
          </div>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="h-100">
      <Card.Body className="d-flex flex-column align-items-center justify-content-center">
        <h5 style={{ color: getThemeColor('dark'), fontWeight: 'bold' }}>
          {title}
        </h5>
        <FlipNumbers
          height={50}
          width={50}
          color={'#3874ff'}
          background="none"
          play
          perspective={500}
          numbers={`${count}`}
          duration={5}
          nonNumberStyle={{ backgroundColor: '#3874ff', marginTop: '20px' }}
        />
      </Card.Body>
    </Card>
  );
};

const styles = {
  spinnerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%', // Make sure the container takes up the full height of the Card body
    width: '100%' // Ensure the container takes up the full width of the Card body
  }
};
export default memo(FlipNumber);
